<template>
  <div class="LookFileModal">
    <a-modal
      title="查看文件"
      :visible="visible"
      destroyOnClose
      centered
      width="1000px"
      :footer="null"
      wrapClassName="full-modal"
      @cancel="handleCancel"
    >
      <a-upload
        v-if="!$route.name.includes('anonymity-query') "
        action="/api/file/docimasy/upload"
        :headers=" {
          'Access-Cookie': $store.state.token,
        }"
        :data="{
          deviceId:deviceId
        }"
        :showUploadList="false"
        @change="uploadChange"
      >
        <a-button type="primary" style="margin-bottom:16px;">
          <a-icon type="upload" />上传文件
        </a-button>
      </a-upload>

      <a-table
        :columns="columns"
        :dataSource="dataSource"
        :rowKey="record => record.id"
        :loading="loading"
        :pagination="page"
      >
        <template slot="createTime" slot-scope="createTime">{{createTime | timeFormat}}</template>

        <template slot="action" slot-scope="text, record">
          <a-button
            v-if="$route.name !== 'anonymity-query-mobile'"
            size="small"
            @click="clickDownload(record.id,record.fileName)"
            style="margin-right:8px;"
          >
            <a-icon type="download" />下载
          </a-button>

          <a-button
            v-if="$route.name !== 'anonymity-query-mobile' && $route.name !== 'anonymity-query'"
            type="danger"
            size="small"
            @click="clickDelete(record.id)"
          >删除</a-button>

          <a-button v-if="$route.name === 'anonymity-query-mobile'" size="small">
            <a :href="`/file/${record.fileUrl}`">下载</a>
          </a-button>
        </template>
      </a-table>
    </a-modal>
  </div>
</template>

<script>
import { getFileList, deleteFile, downloadFile } from '@/api/api'

const columns = [
  // {
  //   title: 'id',
  //   dataIndex: 'id'
  // },
  {
    title: '文件名',
    dataIndex: 'fileName'
  },
  {
    title: '上传时间',
    dataIndex: 'createTime',
    scopedSlots: { customRender: 'createTime' }
  },
  {
    title: '操作',
    dataIndex: 'action',
    scopedSlots: { customRender: 'action' }
  }
]

export default {
  name: 'LookFileModal',

  props: ['visible', 'deviceId'],

  data() {
    return {
      columns,
      dataSource: [],
      loading: false,
      page: {
        showTotal: total => `共 ${total} 条`
      }
    }
  },

  watch: {
    visible(value) {
      if (value) {
        this.fetchData()
      }
    }
  },

  methods: {
    handleCancel() {
      this.$emit('update:visible', false)
    },

    fetchData() {
      this.loading = true
      getFileList(this.deviceId)
        .then(res => {
          if (res.error.code === 0) {
            this.dataSource = res.response.dataList || []
          }
        })
        .finally(() => {
          this.loading = false
        })
    },

    clickDelete(id) {
      this.$confirm({
        title: '确定删除吗？',
        okText: '确定',
        okType: 'danger',
        cancelText: '取消',
        onOk: () => {
          deleteFile(id).then(res => {
            if (res.error.code === 0) {
              this.$message.success('删除成功')
              this.fetchData()
            }
          })
        }
      })
    },

    uploadChange(info) {
      if (info.file.status === 'done') {
        this.$message.success(`${info.file.name}文件上传成功`)
        this.fetchData()
      } else if (info.file.status === 'error') {
        this.$message.error(`${info.file.name}文件上传失败`)
      }
    },

    clickDownload(id, fileName) {
      downloadFile(id).then(res => {
        // 假设 data 是返回来的二进制数据
        const data = res
        const url = window.URL.createObjectURL(new Blob([data]))
        const link = document.createElement('a')
        link.style.display = 'none'
        link.href = url
        link.setAttribute('download', fileName)
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      })
    }

    // clickDownloadMobile(fileUrl) {
    //   const link = document.createElement('a')
    //   link.style.display = 'none'
    //   link.href = fileUrl
    //   link.setAttribute('download', fileName)
    //   document.body.appendChild(link)
    //   link.click()
    //   document.body.removeChild(link)
    // }
  }
}
</script>

<style lang='less' >
.full-modal {
  padding-bottom: 0;
  top: 0px;
  .ant-modal {
    padding-bottom: 0px;
  }
  .ant-modal-body {
    // min-height: calc(100vh - 55px);
  }
}
</style>
